import { ReactNode } from 'react';

import { getReactNodeText, mergeClassNameStrings } from '@consumer-frontend/nc-utils';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/review-fields.scss';

export type NcReviewFieldT = {
  label: ReactNode;
  value: ReactNode;
  chromaticIgnore?: boolean;
};

export type NcReviewFieldsPropsT = {
  fields: NcReviewFieldT[];
  className?: string;
};
export type NcReviewFieldsT = React.FC<NcReviewFieldsPropsT>;

export const NcReviewFields: NcReviewFieldsT = ({ className, fields }) => (
  <dl className={mergeClassNameStrings('review-fields', className)}>
    {fields.map(({
      chromaticIgnore,
      label,
      value,
    }) => (
      <div key={`${getReactNodeText(label)}-${getReactNodeText(value)}`}>
        <dt>{label}</dt>
        <dd data-chromatic={chromaticIgnore ? 'ignore' : undefined}>{value}</dd>
      </div>
    ))}
  </dl>
);
